let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("htt6T")).then(() => parcelRequire('cfd1T'));